module.exports = __webpack_public_path__ + "static/media/Rogue.fc8aa1fd.jpg";